"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReactSession", {
  enumerable: true,
  get: function get() {
    return _ReactSession["default"];
  }
});

var _ReactSession = _interopRequireDefault(require("./ReactSession"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }